__turbopack_context__.v({
  "chubs": "style-module-scss-module__LnDG_a__chubs",
  "curvedBlock": "style-module-scss-module__LnDG_a__curvedBlock",
  "curvedContainer": "style-module-scss-module__LnDG_a__curvedContainer",
  "curvedMask": "style-module-scss-module__LnDG_a__curvedMask",
  "curvedText": "style-module-scss-module__LnDG_a__curvedText",
  "curvedWrapper": "style-module-scss-module__LnDG_a__curvedWrapper",
});
